export default "__VITE_ASSET__c1154e84__"